import { Build, Numbers, Warning, Notes } from '@mui/icons-material';
import { Box } from '@mui/material';
import DOMPurify from 'dompurify';
import { Interweave } from 'interweave';
import React from 'react';

import { MobileReportedInfoProps } from './MobileReportedInfo.props';
import {
  InfoGrid,
  InfoCell,
  InfoLabel,
  InfoValue,
  FullWidthCell,
  FaultBlock,
  NotesBlock,
  NoDataText,
} from './MobileReportedInfo.styles';
import { COLORS } from '../../../../../configs/colors';

export const MobileReportedInfo: React.FC<MobileReportedInfoProps> = ({ service }) => {
  // Split fault and description if combined with " - "
  const faultParts = service.reportedFaultAndDescription?.split(' - ') || [];
  const faultCode = faultParts.length > 1 ? faultParts[0] : service.reportedFaultAndDescription;
  const faultDescription = faultParts.length > 1 ? faultParts.slice(1).join(' - ') : null;

  return (
    <Box sx={{ padding: '16px', backgroundColor: COLORS.White }}>
      <InfoGrid>
        {/* Model */}
        <InfoCell>
          <InfoLabel>
            <Build sx={{ fontSize: 12, verticalAlign: 'middle', mr: 0.5 }} />
            Model
          </InfoLabel>
          <InfoValue>{service.reportedModel || <NoDataText>Not specified</NoDataText>}</InfoValue>
        </InfoCell>

        {/* Serial Number */}
        <InfoCell>
          <InfoLabel>
            <Numbers sx={{ fontSize: 12, verticalAlign: 'middle', mr: 0.5 }} />
            Serial Number
          </InfoLabel>
          <InfoValue>
            {service.reportedSerialNumber || <NoDataText>Not specified</NoDataText>}
          </InfoValue>
        </InfoCell>
      </InfoGrid>

      {/* Fault Information */}
      <FullWidthCell>
        <InfoLabel>
          <Warning sx={{ fontSize: 12, verticalAlign: 'middle', mr: 0.5 }} />
          Reported Fault
        </InfoLabel>
        {service.reportedFaultAndDescription ? (
          <FaultBlock>
            {faultCode && (
              <InfoValue sx={{ fontWeight: 600, mb: faultDescription ? '4px' : 0 }}>
                {faultCode}
              </InfoValue>
            )}
            {faultDescription && (
              <InfoValue sx={{ fontSize: '13px', opacity: 0.9 }}>{faultDescription}</InfoValue>
            )}
          </FaultBlock>
        ) : (
          <InfoValue>
            <NoDataText>Not specified</NoDataText>
          </InfoValue>
        )}
      </FullWidthCell>

      {/* Reported Notes (Creation Notes) */}
      <FullWidthCell sx={{ mb: 0 }}>
        <InfoLabel>
          <Notes sx={{ fontSize: 12, verticalAlign: 'middle', mr: 0.5 }} />
          Reported Notes
        </InfoLabel>
        {service.creationNotes ? (
          <NotesBlock>
            <Interweave content={DOMPurify.sanitize(service.creationNotes)} />
          </NotesBlock>
        ) : (
          <InfoValue>
            <NoDataText>No notes</NoDataText>
          </InfoValue>
        )}
      </FullWidthCell>
    </Box>
  );
};
